import { Label, Select, TextField, ToggleGroup } from '@loadsmart/loadsmart-ui'
import { Selectable } from '@loadsmart/loadsmart-ui/dist/hooks/useSelectable'
import { TranslationMapLoader } from 'common/types/kraken-core/TranslationMap'
import { MessageDirection } from 'common/types/kraken-core/Message'
import { getLoaderMapping } from 'common/helpers/TranslationMapLoader.helpers'
import { useState, useEffect } from 'react'
import { onSearchLoaders } from '../api'
import isEmpty from 'lodash.isempty'
import { Box, Grid } from '@mui/material'

export interface TranslationMapsListFiltersProps {
  filters?: any
  onChange: (changed: any) => void
}

const DATASOURCES = {
  TRANSLATION_MAP_LOADER: [
    () => ({
      type: 'string',
      adapter: {
        getKey: (tt: TranslationMapLoader) => tt.loader || '',
        getLabel: (tt: TranslationMapLoader) => {
          const mapping = getLoaderMapping(tt.loader)
          return `${mapping.name} - ${tt.description || ''}`
        },
      },
      fetch: onSearchLoaders,
    }),
  ],
}

const DIRECTION_FILTER_VALUES = [
  {
    label: 'Inbound',
    value: MessageDirection.INBOUND,
  },
  {
    label: 'Outbound',
    value: MessageDirection.OUTBOUND,
  },
]

export default function TranslationMapsListFilters(props: TranslationMapsListFiltersProps) {
  const [filters, setFilters] = useState<any>(props.filters || {})

  useEffect(() => {
    setFilters(props.filters || {})
  }, [props.filters])

  const handleFilterChanged = (filterName: string, value: any) => {
    const updatedFilters = {
      ...filters,
      [filterName]: value,
    }
    setFilters(updatedFilters)
    props.onChange(updatedFilters)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={5}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Label htmlFor="name">Name</Label>
            <TextField
              id="name"
              value={filters.name || ''}
              onChange={e => handleFilterChanged('name', e.target.value)}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Label htmlFor="loader_selector">Loader</Label>
            <Select
              id="loader_selector"
              name="select_loader"
              onChange={e => {
                handleFilterChanged(
                  'loader',
                  e.target.value ? (e.target.value as TranslationMapLoader) : null
                )
              }}
              value={
                filters.loader
                  ? ({
                      value: filters.loader?.loader,
                      label: filters.loader?.loader
                        ? `${getLoaderMapping(filters.loader.loader).name} - ${
                            filters.loader?.description || ''
                          }`
                        : filters.loader?.description,
                    } as Selectable)
                  : undefined
              }
              datasources={DATASOURCES.TRANSLATION_MAP_LOADER}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={3}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Label htmlFor="direction_selector">Direction</Label>
            <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
              <ToggleGroup
                id="direction_selector"
                name="direction"
                onChange={e => {
                  handleFilterChanged('direction', e.target.value)
                }}
                options={DIRECTION_FILTER_VALUES}
                value={
                  !isEmpty(filters.direction)
                    ? (DIRECTION_FILTER_VALUES.find(
                        v => String(v.value) === String(filters.direction)
                      )?.value as any)
                    : undefined
                }
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}
